import { useState } from "react";
import { Pagination } from "react-bootstrap";
import { fetchPageNumbers, OPTIONS_PAGE } from "./utils";

interface ITablePaginationProps{
  activePage?: number;
  itemsCountPerPage?: number;
  totalItemsCount?: number;
  pageRangeDisplayed?: number;
  onChange?: Function;
  from?: number;
  to?: number;
}

export default function TablePagination({
  activePage = 1, 
  itemsCountPerPage = 10, 
  totalItemsCount = 0, 
  pageRangeDisplayed = 1, 
  onChange,
  from = 0,
  to = 0
}: ITablePaginationProps){
  const [ active, setActive ] = useState(activePage); 
  const __pageRangeDisplayed = Math.max(0, Math.min(pageRangeDisplayed, 2));
  const __totalPages = Math.ceil(totalItemsCount / itemsCountPerPage);
  const pages = fetchPageNumbers(__totalPages,active,__pageRangeDisplayed);

  function handlePageChange(page: number, currentTarget: HTMLElement){
    if(active !== page){
      setActive(page);
      if(onChange) onChange(page);
      currentTarget.blur()
    }
  }

  function renderItems(){
    return (pages.map((page, index) => {
      if (page === OPTIONS_PAGE.LEFT_PAGE) return (
        <Pagination.Prev key={index} className="btn-primary" onClick={({currentTarget})=>handlePageChange(active-1,currentTarget)}/>
      );

      if (page === OPTIONS_PAGE.RIGHT_PAGE) return (
        <Pagination.Next key={index} className="btn-primary" onClick={({currentTarget})=>handlePageChange(active+1,currentTarget)}/>
      );

      return (
        <Pagination.Item key={index}  
          className="btn-primary"
          active={active === page} 
          onClick={({currentTarget})=>handlePageChange(page,currentTarget)}
        >{page}</Pagination.Item>
      );

    }))
  }

  if(!from && !to && !totalItemsCount){
    return <></>;
  }
  return (
    <div className="new-table-pagination-area">
      <div className="new-table-pagination-info">
        {`Mostrando ${from} a ${to} de ${totalItemsCount} registros`}
      </div>
      <Pagination size="sm" className="new-table-pagination">
        {renderItems()}
      </Pagination>
    </div>
  );
}